import { ImageOptimized } from '../image/ImageOptimized';

export type DownloadGameCoverProps = {
  imageUrl: string;
};

export function DownloadGameCover({ imageUrl }: DownloadGameCoverProps) {
  return (
    <ImageOptimized
      alt="game cover"
      width={150}
      height={175}
      layout="fixed"
      src={imageUrl}
    />
  );
}
